import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import styled from 'styled-components'

export function SectionCredit() {
	return (
		<Section>
			<ViewRoot>
				<ViewContent>
					<TextTitle>
						Кредиты <br /> на любые цели
					</TextTitle>
					<Text>• До 15 млн не выходя из дома</Text>
					<Text>• Низкие ставки для клиентов с хорошей кредитной историей</Text>
					<Text>• Все расходы по оформлению сделки за наш счёт</Text>
				</ViewContent>
				<Background name='background-safe' alt='' />
				<Safe name='safe' alt='' />
			</ViewRoot>
		</Section>
	)
}

const Background = styled(Image)(({ theme }) => ({
	display: 'none',
	objectFit: 'contain',
	zIndex: 1,

	[theme.mediaQueries.mediaMinWidthTablet]: {
		display: 'flex',
		height: '100%',
		width: '100%',
	},
}))

const Safe = styled(Image)(({ theme }) => ({
	display: 'none',
	objectFit: 'contain',
	zIndex: 10,

	[theme.mediaQueries.mediaMinWidthTablet]: {
		display: 'flex',
		height: '90%',
		width: '90%',
	},
}))

const ViewRoot = styled.div(({ theme }) => ({
	display: 'flex',
	overflow: 'hidden',
	margin: 0,
	padding: 0,
	marginTop: 120,
	backgroundColor: theme.colors.bluealice,
	borderRadius: 20,
	position: 'relative',
	marginBottom: 20,

	picture: {
		position: 'absolute',
		bottom: -15,
		right: -20,
	},

	[theme.mediaQueries.mediaMinWidthMobile]: {
		borderRadius: 40,
	},
}))
const ViewContent = styled.div(({ theme }) => ({
	paddingTop: 20,
	paddingLeft: 20,
	display: 'flex',
	width: '100%',
	flexDirection: 'column',
	paddingRight: 20,
	zIndex: 1,
	[theme.mediaQueries.mediaMinWidthTablet]: {
		paddingTop: 40,
		maxWidth: '100%',
		paddingLeft: 60,
		paddingRight: 0,
		marginRight: 'auto',
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 10,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text18_24,
	paddingLeft: 12,
	textIndent: -12,
	marginBottom: 15,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 30,
		maxWidth: '75%',
	},
}))
